define.alias("shared/components/shared/appstore-links", "preview-grid/components/shared/appstore-links");